import Login from '@/views/login/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import ApiTest from '@/views/ApiTest.vue';
// 学生模块
import StudentProfile from '@/views/student/Profile.vue';
import HealthAnalysis from '@/views/student/HealthAnalysis.vue';
// import HealthAdvice from '@/views/student/HealthAdvice.vue';
// 现在使用 NewHealthAdvice 组件
// import NewHealthAdvice from '@/views/student/NewHealthAdvice.vue'; // 现在直接通过路由懒加载引入
import MessageBoard from '@/views/student/MessageBoard.vue';
// 教师模块
import StudentManagement from '@/views/teacher/StudentManagement.vue';
import MakeupApproval from '@/views/teacher/MakeupApproval.vue';
import TeacherProfile from '@/views/teacher/Profile.vue';
import FitnessScoreManagement from '@/views/teacher/FitnessScoreManagement.vue';
import ClassHealthOverview from '@/views/teacher/ClassHealthOverview.vue';

import TeacherMessageBoard from '@/views/teacher/MessageBoard.vue';
// 管理员模块
import UserManagement from '@/views/admin/UserManagement.vue';
import MakeUpExamManagement from '@/views/admin/MakeUpExamManagement.vue';
import ScoreManagement from '@/views/admin/ScoreManagement.vue';
import ActivityManagement from '@/views/admin/ActivityManagement.vue';
import InformationManagement from '@/views/admin/InformationManagement.vue';
import TestItemManagement from '@/views/admin/TestItemManagement.vue';
import ScoringStandardManagement from '@/views/admin/ScoringStandardManagement.vue';
// 删除权限管理和数据备份组件的导入
import MessageBoardManagement from '@/views/admin/MessageBoardManagement.vue';
// 公共组件
import NotFound from '@/views/NotFound.vue';
import Unauthorized from '@/views/Unauthorized.vue';
import { useAuthStore } from '@/store/modules/auth';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {    
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/api-test',
    name: 'ApiTest',
    component: ApiTest,
    meta: { requiresAuth: false }
  },
  // 学生路由
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, role: 'student' }
  },
  {    
    path: '/student/profile',
    name: 'StudentProfile',
    component: StudentProfile,
    meta: { requiresAuth: true, role: 'student' },
    children: [
      {
        path: 'info',
        name: 'StudentPersonalInfo',
        component: StudentProfile,
        meta: { requiresAuth: true, role: 'student' }
      },
      {
        path: 'videos',
        name: 'StudentVideos',
        component: StudentProfile,
        meta: { requiresAuth: true, role: 'student' }
      },
      {
        path: 'makeup',
        name: 'StudentMakeup',
        component: StudentProfile,
        meta: { requiresAuth: true, role: 'student' }
      },
      // 重定向到info子路由
      {
        path: '',
        redirect: 'info'
      }
    ]
  },
  {
    path: '/student/records',
    name: 'FitnessRecords',
    component: () => import('@/views/student/FitnessRecords.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/health',
    name: 'HealthAnalysis',
    component: HealthAnalysis,
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/health-advice',
    name: 'HealthAdvice',
    component: () => import('@/views/student/NewHealthAdvice.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  // {
  //   path: '/student/new-health-advice',
  //   name: 'NewHealthAdvice',
  //   component: NewHealthAdvice,
  //   meta: { requiresAuth: true, role: 'student' }
  // },
  // 健康追踪模块已移除
  {    
    path: '/student/message-board',
    name: 'MessageBoard',
    component: MessageBoard,
    meta: { requiresAuth: true, role: 'student' }
  },
  // 教师路由
  {
    path: '/teacher/students',
    name: 'StudentManagement',
    component: StudentManagement,
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/fitness-scores',
    name: 'FitnessScoreManagement',
    component: FitnessScoreManagement,
    meta: { requiresAuth: true, role: 'teacher' }
  },

  {
    path: '/teacher/makeup',
    name: 'MakeupApproval',
    component: MakeupApproval,
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/profile',
    name: 'TeacherProfile',
    component: TeacherProfile,
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/class-health',
    name: 'ClassHealthOverview',
    component: ClassHealthOverview,
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/message-board',
    name: 'TeacherMessageBoard',
    component: TeacherMessageBoard,
    meta: { requiresAuth: true, role: 'teacher' }
  },
  // 管理员路由
  {
    path: '/admin/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true, role: 'admin' }
  },
  {
    path: '/admin/makeup-exams',
    name: 'MakeUpExamManagement',
    component: MakeUpExamManagement,
    meta: { requiresAuth: true, role: 'admin' }
  },
  {
    path: '/admin/score-management',
    name: 'ScoreManagement',
    component: ScoreManagement,
    meta: { requiresAuth: true, role: 'admin' }
  },
  {
    path: '/admin/activities',
    name: 'ActivityManagement',
    component: ActivityManagement,
    meta: { requiresAuth: true, role: 'admin' }
  },
  {
    path: '/admin/information',
    name: 'InformationManagement',
    component: InformationManagement,
    meta: { requiresAuth: true, role: 'admin' }
  },
  {
    path: '/admin/test-items',
    name: 'TestItemManagement',
    component: TestItemManagement,
    meta: { requiresAuth: true, role: 'admin' }
  },
  {
    path: '/admin/scoring-standards',
    name: 'ScoringStandardManagement',
    component: ScoringStandardManagement,
    meta: { requiresAuth: true, role: 'admin' }
  },
  {
    path: '/admin/message-board',
    name: 'MessageBoardManagement',
      component: MessageBoardManagement,
      meta: { requiresAuth: true, role: 'admin' }
    },
    // 删除数据备份路由
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: Unauthorized
    },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  
  // 1. 从localStorage恢复认证状态
  const storedToken = localStorage.getItem('token');
  const storedUsername = localStorage.getItem('username');
  const storedRole = localStorage.getItem('role');
  
  if (storedToken) {
    authStore.token = storedToken;
    authStore.username = storedUsername || '';
    authStore.role = storedRole || '';
    authStore.isAuthenticated = true;
  }
  
  // 2. 不需要认证的页面直接放行
  if (!to.meta.requiresAuth) {
    // 注释掉这段代码，允许已认证用户访问登录页
    // 已认证用户访问登录页时重定向到对应首页
    if (to.path === '/login' && authStore.isAuthenticated) {
      if (authStore.isStudent()) return next('/');
      if (authStore.isTeacher()) return next('/teacher/profile');
      if (authStore.isAdmin()) return next('/admin/activities');
    }
    return next();
  }
  
  // 3. 未认证用户访问需要认证的页面
  if (!authStore.isAuthenticated) {
    return next('/login');
  }
  
  // 4. 页面刷新时(from.name为null)，直接放行
  if (from.name === null) {
    return next();
  }
  
  // 5. 正常导航时的角色权限检查
  if (to.meta.role) {
    const isAuthorized = authStore[`is${to.meta.role.charAt(0).toUpperCase() + to.meta.role.slice(1)}`]();
    if (!isAuthorized) {
      // 根据角色重定向到对应首页
      if (authStore.isStudent()) return next('/');
      if (authStore.isTeacher()) return next('/teacher/profile');
      if (authStore.isAdmin()) return next('/admin/activities'); // 修改为体测活动管理页面
      return next('/unauthorized');
    }
  }
  
  // 6. 已认证用户访问unauthorized页面时重定向
  if (to.path === '/unauthorized') {
    if (authStore.isStudent()) return next('/');
    if (authStore.isTeacher()) return next('/teacher/profile');
    if (authStore.isAdmin()) return next('/admin/activities'); // 修改为体测活动管理页面
  }
  
  next();
});

export default router;